import { Fragment } from 'react/jsx-runtime';
import { useStoreSelector } from 'v3/data/store';
import { setCancelationErrorModalOpen, setCancelationModalOpen, setCurrentCancellationState } from 'v3/data/store/cancellationNavigation/actions';
import { CancellationNavigationEnum } from 'v3/data/store/cancellationNavigation/enum';
import { cancellationSteps, REQUEST_CANCELLATION_INDEX } from 'v3/pages/OnlineContracting/Cancellation/constants';
import {
  CpfItem,
  CpfSection,
  InfoSection,
  PaymentInfoItem,
} from 'v3/pages/OnlineContracting/Cancellation/Steps/RequestCancellationStep/styles';
import { AlignButtons, Content } from 'v3/pages/OnlineContracting/Cancellation/styles';
import * as onlineApi from 'v3/services/online/api';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { TextButton } from 'v3/shared/components/Button/TextButton';
import { HorizontalStepper } from 'v3/shared/components/HorizontalStepper';
import { BodyMediumBold } from 'v3/shared/typography/BodyMedium';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { theme } from 'v3/styles/global-styles';

export const RequestCancellationStep = () => {
  const { contractingKey, paymentDetails } = useStoreSelector((store) => store.onlineContracting);

  const handleRequestCancellation = async () => {
    try {
      await onlineApi.requestCancellation(contractingKey, {
        vtexPaymentId: paymentDetails.paymentId,
        vtexOrderId: paymentDetails.orderId,
        reason: 'Requisição do cancelamento feita pelo Backoffice',
      });
      setCurrentCancellationState(CancellationNavigationEnum.CANCELLATION_STARTED);
    } catch (error) {
      console.error('Error requesting cancellation:', error);
      setCancelationErrorModalOpen(true);
    }
  };

  const handleCancel = () => {
    setCancelationModalOpen(false);
  };

  return (
    <Fragment>
      <HorizontalStepper activeStepIndex={REQUEST_CANCELLATION_INDEX} steps={cancellationSteps} />

      <Content>
        <SubtitleMedium color={theme.palette.secondary.light}>
          {'Ao realizar a solicitação será dado início ao processo de congelamento dos pagamentos'}
        </SubtitleMedium>
        <InfoSection>
          <PaymentInfoItem>
            <SubtitleMedium color={theme.palette.secondary.light}>{'ID do pagamento'}</SubtitleMedium>
            <BodyMediumBold className="empty-line">{paymentDetails.paymentId ?? ''}</BodyMediumBold>
          </PaymentInfoItem>
          <PaymentInfoItem>
            <SubtitleMedium color={theme.palette.secondary.light}>{'Nome'}</SubtitleMedium>

            <BodyMediumBold>{paymentDetails.buyer.fullName}</BodyMediumBold>
          </PaymentInfoItem>
        </InfoSection>
        <CpfSection>
          <CpfItem>
            <SubtitleMedium color={theme.palette.secondary.light}>CPF</SubtitleMedium>
            <BodyMediumBold>{paymentDetails.buyer.cpf}</BodyMediumBold>
          </CpfItem>
        </CpfSection>
        <AlignButtons>
          <TextButton fullWidth text="Cancelar" $outline size="small" handleClick={handleCancel} />
          <FlexButton fullWidth text="Sim, quero solicitar" size="small" handleClick={handleRequestCancellation} />
        </AlignButtons>
      </Content>
    </Fragment>
  );
};
